import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/authentication/login.service';

@Component({
  selector: 'app-logihome',
  templateUrl: './logihome.component.html',
  styleUrls: ['./logihome.component.css']
})
export class LogihomeComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) { }

	ngOnInit() {
		this.menu = [
			{name:'Admin Logística', desc:'Administrador Logística', icon:'fas fa-cogs', url:'/adminlogistics', perm: 'LOGI-ADMIN'},
			{name:'Conductor', desc:'Módulo conductor', icon:'fas fa-user', url:'/driverhomelogistics', perm: 'LOGI-DRIVER'},
      {name:'Tracking por Documento', desc:'Reporte Tracking', icon:'fas fa-map-marked-alt', url:'/trackingreport', perm: 'LOGI-TRACKING_REPORT'}
      /*
      {name:'Reportes', desc:'Módulo reportería', icon:'fas fa-chart-area', url:'/logistics', perm: 'LOGI-DRIVER'},
      {name:'Cliente', desc:'Módulo cliente', icon:'fas fa-user-tie', url:'/clientstatuslogistics', perm: 'LOGI-DRIVER'},*/
		];

		this.auth.getPermissions().then(x => {
            this.permissions = x;
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
